import Blockly from "blockly";
import Schema from "../schema";
import {
  Characters,
} from '../data';

export const menu = {
  name: (<div className="text">L<u>o</u>gic</div>),
  trigger: 'o',
  children: {
    'if_player': {
      name: (<div className="text">If <u>P</u>layer</div>),
      trigger: 'p',
    },
    'if_subscriber': {
      name: (<div className="text">If <u>S</u>ubscriber</div>),
      trigger: 's',
    },
    'when_room': {
      name: (<div className="text"><u>W</u>hen current room</div>),
      trigger: 'w',
    },
    'randomize': {
      name: (<div className="text"><u>R</u>andom Action</div>),
      trigger: 'r',
    },
    'cmd_block': {
      name: (<div className="text"><u>C</u>ommand Block</div>),
      trigger: 'c',
    },
    'timed': {
      name: (<div className="text"><u>T</u>imed Actions</div>),
      trigger: 't',
    },
    'repeat': {
      name: (<div className="text">R<u>e</u>peat Action</div>),
      trigger: 'l',
    },
    'define_param': {
      name: (<div className="text"><u>D</u>efine Command Parameter</div>),
      trigger: 'd'
    },
    'param_get': {
      name: (<div className="text"><u>G</u>et Command Parameter</div>),
      trigger: 'g'
    },
    'say': {
      name: (<div className="text">Say in <u>C</u>hat</div>),
      trigger: 'c',
    },
    'do_nothing': {
      name: (<div className="text">Do <u>N</u>othing (NOOP command)</div>),
      trigger: 'n',
    }
  }
}

/* ****************************************************************************************************************
 * If Player
 ******************************************************************************************************************/
Blockly.Blocks['if_player'] = {
  init: function () {
    this.appendDummyInput('if')
      .appendField('If the current player is ')
      .appendField(
        new Blockly.FieldDropdown(
          [].concat(
            Characters.sort((a, b) => a[0] > b[0] ? 1 : -1)
          )
        ),
        'Player'
      );
    this.appendStatementInput('Content')
      .setCheck(null);

    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setColour('#000000');
    this.setTooltip("");
    this.setHelpUrl("");
  }
};

Blockly.JSON['if_player'] = (block) => {
  let player = parseInt(block.getFieldValue('Player'), 10);
  let actions = Blockly.JSON.statementToCode(block, 'Content');

  return {
    action: 'if_player',
    params: {
      player,
      actions
    }
  }
}

Schema.registerAction('if_player', {
  "if": {
    "properties": {
      "action": {
        "const": "if_player"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "player": {
            "type": "number"
          },
          "actions": {
            "allOf": [
              {
                "$ref": "#/definitions/Actions"
              }
            ],
            "items": {
              "anyOf": [
                {
                  "if": {
                    "properties": {
                      "action": {
                        "const": "if_player"
                      }
                    }
                  },
                  "then": {
                    "required": [
                      "nesting_prohibited"
                    ]
                  }
                }
              ]
            }
          }
        },
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ]
  }
});

/* ****************************************************************************************************************
 * Say in chat.
 ******************************************************************************************************************/
Blockly.Blocks['say'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_string');
    shadow.setMaxLength(250);
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['string'])
      .appendField('Display the following message in chat')
      .connection
      .connect(shadow.outputConnection)

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Display the following message in chat.');
  }
};

Blockly.JSON['say'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    if (params.hasOwnProperty('value')) {
      params['message'] = params['value'];
      delete params.value
    }

    return {
      action: 'say',
      params
    }
  } else return;
};

Schema.registerAction('say', {
  "if": {
    "properties": {
      "action": {
        "const": "say"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "string": {
            "type": "string",
          },
          "from_param": {
            "type": "string",
          }
        },
        "oneOf": [
          {
            "required": [
              "string"
            ]
          },
          {
            "required": [
              "from_param"
            ]
          }
        ],
        "additionalProperties": false
      },
    }
  }
})

/* ****************************************************************************************************************
 * If Subscriber
 ******************************************************************************************************************/
Blockly.Blocks['if_subscriber'] = {
  init: function () {
    this.appendDummyInput('if')
      .appendField('If the person issuing this command is a subscriber, then perform')
    this.appendStatementInput("Content")
      .setCheck(null)
    this.appendDummyInput('otherwise, perform')
      .appendField('Otherwise')
    this.appendStatementInput("Else")
      .setCheck(null)
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setColour('#000000');
    this.setTooltip("");
    this.setHelpUrl("");
  }
};

Blockly.JSON['if_subscriber'] = (block) => {
  let actions = Blockly.JSON.statementToCode(block, 'Content');
  let else_actions = Blockly.JSON.statementToCode(block, 'Else');

  return {
    action: 'if_subscriber',
    params: {
      if_true: {
        actions
      },
      if_false: {
        actions: else_actions
      },
    }
  }
}


Schema.registerAction('if_subscriber', {
  "if": {
    "properties": {
      "action": {
        "const": "if_subscriber"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "if_true": {
            "properties": {
              "actions": {
                "allOf": [
                  {
                    "$ref": "#/definitions/Actions"
                  }
                ],
                "items": {
                  "anyOf": [
                    {
                      "if": {
                        "properties": {
                          "action": {
                            "const": "if_subscriber"
                          }
                        }
                      },
                      "then": {
                        "required": [
                          "nesting_prohibited"
                        ]
                      }
                    }
                  ]
                }
              }
            },
            "additionalProperties": false
          },
          "if_false": {
            "properties": {
              "actions": {
                "allOf": [
                  {
                    "$ref": "#/definitions/Actions"
                  }
                ],
                "items": {
                  "anyOf": [
                    {
                      "if": {
                        "properties": {
                          "action": {
                            "const": "if_subscriber"
                          }
                        }
                      },
                      "then": {
                        "required": [
                          "nesting_prohibited"
                        ]
                      }
                    }
                  ]
                }
              }
            },
            "additionalProperties": false
          }
        },
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ]
  }
});

/* ****************************************************************************************************************
 * When Room Action
 ******************************************************************************************************************/
Blockly.Blocks['when_room'] = {
  init: function () {
    this.appendDummyInput('Definition')
      .appendField('When the current room')
      .appendField(
        new Blockly.FieldDropdown([
          ["is cleared", "cleared"],
        ]),
        'RoomState'
      );
    this.appendStatementInput('Content')
      .setCheck(null);

    this.setInputsInline(false);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setColour('#000000');
    this.setTooltip("");
    this.setHelpUrl("");
  }
};

Blockly.JSON['when_room'] = (block) => {
  let roomstate = block.getFieldValue('RoomState');
  let actions = Blockly.JSON.statementToCode(block, 'Content');

  return {
    action: 'when_room',
    params: {
      roomstate,
      actions
    }
  }
}

Schema.registerAction('when_room', {
  "if": {
    "properties": {
      "action": {
        "const": "when_room"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "roomstate": {
            "enum": [
              "cleared",
            ],
          },
          "actions": {
            "allOf": [
              {
                "$ref": "#/definitions/Actions"
              }
            ],
            "items": {
              "anyOf": [
                {
                  "if": {
                    "properties": {
                      "action": {
                        "const": "when_room"
                      }
                    }
                  },
                  "then": {
                    "required": [
                      "nesting_prohibited"
                    ]
                  }
                }
              ]
            }
          }
        },
        "additionalProperties": false,
      }
    },
    "required": [
      "params"
    ]
  }
});


/* ****************************************************************************************************************
 * Random Action
 ******************************************************************************************************************/
Blockly.Blocks['randomize'] = {
  init: function () {
    this.appendDummyInput('say')
      .appendField('Run one of the following actions at random:')
    this.appendStatementInput("Content")
      .setCheck(null);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setColour('#000000');
    this.setTooltip("");
    this.setHelpUrl("");
  }
};

Blockly.JSON['randomize'] = (block) => {
  let actions = Blockly.JSON.statementToCode(block, 'Content');

  return {
    action: 'randomize',
    params: {
      actions
    }
  }
}

Schema.registerAction('randomize', {
  "if": {
    "properties": {
      "action": {
        "const": "randomize"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "actions": {
            "allOf": [
              {
                "$ref": "#/definitions/Actions"
              }
            ],
            "items": {
              "anyOf": [
                {
                  "if": {
                    "properties": {
                      "action": {
                        "const": "randomize"
                      }
                    }
                  },
                  "then": {
                    "required": [
                      "nesting_prohibited"
                    ]
                  }
                }
              ]
            }
          }
        }
      }
    },
    "required": [
      "params"
    ]
  }
});

/* ****************************************************************************************************************
 * Command Block
 ******************************************************************************************************************/
Blockly.Blocks['cmd_block'] = {
  init: function () {
    this.appendDummyInput('say')
      .appendField('Run the following commands in order:')
    this.appendStatementInput("Content")
      .setCheck(null);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setColour('#000000');
    this.setTooltip("");
    this.setHelpUrl("");
  }
};

Blockly.JSON['cmd_block'] = (block) => {
  let actions = Blockly.JSON.statementToCode(block, 'Content');

  return {
    action: 'cmd_block',
    params: {
      actions
    }
  }
}

Schema.registerAction('cmd_block', {
  "if": {
    "properties": {
      "action": {
        "const": "cmd_block"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "actions": {
            "allOf": [
              {
                "$ref": "#/definitions/Actions"
              }
            ],
            "items": {
              "anyOf": [
                {
                  "if": {
                    "properties": {
                      "action": {
                        "const": "cmd_block"
                      }
                    }
                  },
                  "then": {
                    "required": [
                      "nesting_prohibited"
                    ]
                  }
                }
              ]
            }
          }
        }
      }
    },
    "required": [
      "params"
    ]
  }
});

/* ****************************************************************************************************************
 * Timed Action
 ******************************************************************************************************************/
Blockly.Blocks['timed'] = {
  init: function () {
    this.appendDummyInput('Definition')
      .appendField('Wait')
      .appendField(
        new Blockly.FieldTextInput(
          '30',
          this.validateCount.bind(this)
        ),
        'Duration'
      )
      .appendField('seconds, and then perform the following actions');
    this.appendStatementInput('Content')
      .setCheck(null);

    this.setInputsInline(false);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setColour('#000000');
    this.setTooltip("");
    this.setHelpUrl("");

    if (!this.data) {
      this.setMinimum(1)
      this.setMaximum(600);
    }
  },
  onchange: function (event) {
    if (this.data) {
      const data = JSON.parse(this.data);
      this.minimum = data.minimum;
      this.maximum = data.maximum;
    }
    this.setTooltip(`Enter a number between ${this.minimum} and ${this.maximum}`);
  },
  setMinimum: function (value) {
    this.minimum = value;
    this.data = JSON.stringify({
      minimum: this.minimum,
      maximum: this.maximum,
    })
    this.setTooltip(`Enter a number between ${this.minimum} and ${this.maximum}`);
  },
  setMaximum: function (value) {
    this.maximum = value;
    this.data = JSON.stringify({
      minimum: this.minimum,
      maximum: this.maximum,
    })
    this.setTooltip(`Enter a number between ${this.minimum} and ${this.maximum}`);
  },
  validateCount: function (value) {
    let re = new RegExp('^[-0-9.]+$');
    if (!re.test(value)) {
      return null;
    } else {
      let num = parseFloat(value, 10);
      if (num < this.minimum) return null;
      if (num > this.maximum) return null;
    }
  }
};


Blockly.JSON['timed'] = (block) => {
  let duration = parseInt(block.getFieldValue('Duration'), 10);
  let actions = Blockly.JSON.statementToCode(block, 'Content');

  return {
    action: 'timed',
    params: {
      duration,
      actions
    }
  }
}

Schema.registerAction('timed', {
  "if": {
    "properties": {
      "action": {
        "const": "timed"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "duration": {
            "type": "number",
          },
          "actions": {
            "allOf": [
              {
                "$ref": "#/definitions/Actions"
              }
            ],
            "items": {
              "anyOf": [
                {
                  "if": {
                    "properties": {
                      "action": {
                        "const": "timed"
                      }
                    }
                  },
                  "then": {
                    "required": [
                      "nesting_prohibited"
                    ]
                  }
                }
              ]
            }
          }
        },
        "additionalProperties": false,
      }
    },
    "required": [
      "params"
    ]
  }
});

/* ****************************************************************************************************************
 * Repeat Action
 ******************************************************************************************************************/
Blockly.Blocks['repeat'] = {
  init: function () {
    this.appendDummyInput('Definition')
      .appendField('Repeat the following actions')
      .appendField(
        new Blockly.FieldTextInput(
          '5',
          this.validateCount.bind(this)
        ),
        'Count'
      )
      .appendField('times.');
    this.appendStatementInput('Content')
      .setCheck(null);

    this.setInputsInline(false);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setColour('#000000');
    this.setTooltip("");
    this.setHelpUrl("");

    if (!this.data) {
      this.setMinimum(1)
      this.setMaximum(50);
    }
  },
  onchange: function (event) {
    if (this.data) {
      const data = JSON.parse(this.data);
      this.minimum = data.minimum;
      this.maximum = data.maximum;
    }
    this.setTooltip(`Enter a number between ${this.minimum} and ${this.maximum}`);
  },
  setMinimum: function (value) {
    this.minimum = value;
    this.data = JSON.stringify({
      minimum: this.minimum,
      maximum: this.maximum,
    })
    this.setTooltip(`Enter a number between ${this.minimum} and ${this.maximum}`);
  },
  setMaximum: function (value) {
    this.maximum = value;
    this.data = JSON.stringify({
      minimum: this.minimum,
      maximum: this.maximum,
    })
    this.setTooltip(`Enter a number between ${this.minimum} and ${this.maximum}`);
  },
  validateCount: function (value) {
    let re = new RegExp('^[-0-9.]+$');
    if (!re.test(value)) {
      return null;
    } else {
      let num = parseFloat(value, 10);
      if (num < this.minimum) return null;
      if (num > this.maximum) return null;
    }
  }
};


Blockly.JSON['repeat'] = (block) => {
  let count = parseInt(block.getFieldValue('Count'), 10);
  let actions = Blockly.JSON.statementToCode(block, 'Content');

  return {
    action: 'repeat',
    params: {
      count,
      actions
    }
  }
}

Schema.registerAction('repeat', {
  "if": {
    "properties": {
      "action": {
        "const": "repeat"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "count": {
            "type": "number",
          },
          "actions": {
            "allOf": [
              {
                "$ref": "#/definitions/Actions"
              }
            ],
            "items": {
              "anyOf": [
                {
                  "if": {
                    "properties": {
                      "action": {
                        "const": "repeat"
                      }
                    }
                  },
                  "then": {
                    "required": [
                      "nesting_prohibited"
                    ]
                  }
                }
              ]
            }
          }
        },
        "additionalProperties": false,
      }
    },
    "required": [
      "params"
    ]
  }
});

/* ****************************************************************************************************************
 * User Is
 *****************************************************************************************************************
Blockly.Blocks['user_is'] = {
  init: function () {
    this.appendDummyInput('user_is')
      .appendField('User is')
      .appendField(
        new Blockly.FieldDropdown([
          ['a subscriber', 'isSub'],
          ['a moderator', 'isMod'],
        ]), 'State')
    this.setOutput(true, 'Boolean');
  }
}

Blockly.JSON['user_is'] = (block) => {
  let value = block.getFieldValue('State');

  return {
    if_condition: {
      source: 'state',
      field: value,
    }
  };
};
*/


/* ****************************************************************************************************************
 * Does absolutely nothing.
 ******************************************************************************************************************/
Blockly.Blocks['do_nothing'] = {
  init: function () {
    this.appendDummyInput('Input')
      .appendField('This command does nothing at all. I am serious. It will not do anything. Please believe me.')
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Does nothing.')
  }
}

Blockly.JSON['do_nothing'] = (block) => {
  return {
    action: 'do_nothing',
  }
}

Schema.registerAction('do_nothing', {
  "if": {
    "properties": {
      "action": {
        "const": "do_nothing"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {},
        "additionalProperties": false
      }
    }
  }
});